import axios from "axios";

export const AxiosInterceptor = axios.create({
    baseURL: process.env.REACT_APP_BASEURL,
});


export const TokenAxiosInterceptor = axios.create({
    baseURL: process.env.REACT_APP_BASEURL,
});

TokenAxiosInterceptor.interceptors.request.use(
    (config) => {
        const token = window.localStorage.getItem("token");

        if(!token){
            console.log("token없음");
            return;
        } else {
            config.headers["Authorization"] = `${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
)
